
export { SettingsModule } from './settings.module';
export { SettingsComponent } from './settings.component';
export { CanAccessSettingsGuard } from './can-access-settings.guard';